import { ActionCard } from '@pcln/horizon'
import { OptInCard } from '@pcln/marketing'
import { Box, Flex } from 'pcln-design-system'

import useBootstrapData from '@/hooks/useBootstrapData'
import useHandleAppDownloadSubmit from '@/hooks/useHandleAppDownloadSubmit'

import { CONTENT, trackHelpCenter, trackMyTrips } from './utils'

export default function AppDownloadOptIn() {
  const [handleSubmitNumber, signUpState] = useHandleAppDownloadSubmit()
  const { signInStatus } = useBootstrapData()
  return (
    <Flex>
      <Box mr={3}>
        <OptInCard
          {...CONTENT}
          desktopImageAlignment='right'
          signUpState={signUpState}
          handleFormSubmit={handleSubmitNumber}
        />
      </Box>
      <Flex flexDirection='column' style={{ gap: 16 }}>
        <ActionCard
          role='button'
          mediaType='icon'
          mediaContent='luggage'
          heading='My Trips'
          body='Quickly find your booking reservations and redeem flight credits'
          onClick={() => trackMyTrips(signInStatus.signedIn)}
        />
        <ActionCard
          role='button'
          mediaType='icon'
          mediaContent='help'
          heading='Help Center'
          body='We are always Here for you - reach us 24hrs a day, 7 days a week'
          onClick={trackHelpCenter}
        />
      </Flex>
    </Flex>
  )
}
